import imageCompression from 'browser-image-compression';
import axios from 'axios';
import config from '../../../../../config/config';
import { getStore, getSessionStore } from '../../../../../../src/store/createStore';
import { getImagePath } from '../../../../common/productImageUtils';

const imageCompressionHandler = async ({ fileData }) => {
	return imageCompression(fileData, {
		maxSizeMB: 3,
		// maxWidthOrHeight: 1920,
		useWebWorker: true,
		maxIteration: 15,
		onProgress: prog => {}
	});
};

export const getRandomColor = (noImage, colorToSkip = '') => {
	let noImageStyle = {};

	if (noImage) {
		const backgroundColor = [
			'FCF4FF',
			'FDF9F1',
			'F6F7FD',
			'EEFAF7',
			'FFEFF9',
			'EAFAFF',
			'FFF4F4'
		];
		const randomNum = Math.floor(Math.random() * (7 - 0)) + 0; //The maximum is exclusive and the minimum is inclusive
		const color = '#' + backgroundColor[randomNum];
		if (color == colorToSkip) {
			return getRandomColor(noImage, colorToSkip);
		}
		return (noImageStyle = {
			background: '#' + backgroundColor[randomNum]
		});
	} else {
		return noImageStyle;
	}
};

const getShortUrl = async url => {
	const { data } = await axios.get(
		`https://omni.justdial.com/marketplace/static/php/web/common_api.php?action=shortenUrl&url=${encodeURI(
			url
		)}`
	);
	if (data.success) {
		return data.shortUrl;
	}
	return url;
};

let fileCount = 0;
const generateFileId = () => {
	return (
		Math.random()
			.toString()
			.substring(2, 6) + fileCount++
	);
};

const uploadFileReq = (formData,url) => {
    const state = getStore().getState();
	formData.append('supplier_id', state?.session?.supplierId);
	return axios({
		// url: `/marketplace/nj/file-upload/upload?type=prescription`,
		url: `/vendorapis/products/product/uploadb2bClientFile`,
		method: 'POST',
		data: formData, // Data sent to server, a set of key/value pairs (i.e. form fields and values)
		cache: false
	});
};

const uploadSingleFile = ({ cb, file, randomId, key }) => {
	const formData = new FormData();
	formData.append('file', file);
	uploadFileReq(formData)
		.then(async ({ data }) => {
			if (!data.isError) {
				let fileUrl = atob(data.filePath);
				const imageDomainUrl = config.B2B_URL;
				fileUrl = fileUrl.trim().replace('/MP_FILESHARE', imageDomainUrl+"/downloads");
				const shortUrl = await getShortUrl(fileUrl);
				const fileType = fileUrl
					.split('.')
					.pop()
					.toLowerCase();
				const cbData = {
					id: randomId,
					shortUrl,
					url: fileUrl,
					uploaded: true,
					success: true,
					fileType,
					key
				};
				cb(cbData);
			}
		})
		.catch(() => {
			console.log('Catched Error Here', randomId);
			cb(null, randomId);
		});
};

const toBase64 = file =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = error => reject(error);
	});

const uploadToNewAPI=({ cb, file, key, randomId })=>{
	const formData = new FormData();
	formData.append(`file[0]`, file);
	uploadFileReq(formData, "/vendorapis/products/product/uploadImage").then(async({ data }) => {
		if (data?.errors?.code != 0) {
			throw Exception("uploadToNewAPI: " + data?.errors?.msg)
		}
		if (Array.isArray(data?.url) && data?.url?.length > 0) {
			var reg = new RegExp(/(^\/?(quickquotes|comp\/def_content|rep))/);
			const imageDomain=reg.test(data?.url[0])?config.staticImageDomains[3]:config.NEW_UPLOAD_URL;
			const fileUrl=`${imageDomain}${!imageDomain?.endsWith("/")?"/":""}${data?.url[0]}`
			const shortUrl = await getShortUrl(fileUrl)
			const fileType = fileUrl
					.split('.')
					.pop()
					.toLowerCase();
			const cbData = {
				id: randomId,
				shortUrl,
				url: fileUrl,
				uploaded: true,
				success: true,
				fileType,
				key
			};
			cb(cbData);
		}
	}).catch(e=>cb(null, randomId))
}

export const uploadMultipleFiles = async ({files: fileList,usingNewAPI=false, cb} ) => {

	for (let key in fileList) {
		if (!fileList.hasOwnProperty(key)) {
			continue;
		}
		const fileData = fileList[key];
		const randomId = generateFileId();
		const extension = fileData.name
			.split('.')
			.pop()
			.toLowerCase();
		if (extension === 'pdf') {
			toBase64(fileData).then(cur => {
				console.timeEnd('pdf');
				const cbPdf = {
					id: randomId,
					url: cur,
					fileType: extension,
					uploaded: false,
					success: true,
					key: fileData.key
				};
				if(usingNewAPI){
					uploadToNewAPI({
						cb,
						file: fileData,
						key: fileData.key,
						randomId
					});
				}else{
					uploadSingleFile({
						cb,
						file: fileData,
						key: fileData.key,
						randomId
					});
				}
				cb(cbPdf);
			});
		} else {
			imageCompressionHandler({ fileData }).then(compressedFile => {
				console.log(
					`compressedFile size ${compressedFile.size /
						1024 /
						1024} MB`
				);
				compressedFile = new File([compressedFile], fileData.name); //required for file upload service
				const fileType = fileData.name
					.split('.')
					.pop()
					.toLowerCase();
				imageCompression
					.getDataUrlFromFile(compressedFile)
					.then(base64Url => {
						const cbData = {
							id: randomId,
							url: base64Url,
							uploaded: false,
							fileType,
							success: true,
							key: fileData.key
						};
						// cb(cbData);
					});
				if(usingNewAPI){
					uploadToNewAPI({
						cb,
						file: compressedFile,
						key: fileData.key,
						randomId
					});
				} else{
					uploadSingleFile({
						cb,
						file: compressedFile,
						key: fileData.key,
						randomId
					});
				}
			})
			.catch(e=>{
				cb({...e,success:false,decodingError:true})
			})
			// let compressedFile = new File([fileData], fileData.name);
			// uploadSingleFile({
			// 	cb,
			// 	file: compressedFile,
			// 	randomId
			// });
		}
	}
};

export const getDisputeList = ({ supId, cb, id, accept, filter, pageNo }) => {
	let url = `/marketplace/static/php/jdCourier/getWeightIssueList.php?supplierId=${supId}`;
	if (id) {
		url += `&id=${id}`;
	}
	if (accept) {
		url += `&accept=${accept}`;
	}
	if (filter && filter.length) {
		filter.map(cur => {
			url += `&filter[]=${cur}`;
		});
	}
	if (pageNo) {
		url += `&page=${pageNo}`;
	}
	axios.get(url).then(data => {
		cb(data.data);
	});
};

const CancelToken = axios.CancelToken;
let cancel;

export const searchDisputeList = ({
	supId,
	searchTerm,
	cb,
	pageNo,
	filter
}) => {
	if (cancel !== undefined) cancel();
	let url = `/marketplace/static/php/jdCourier/getWeightIssueList.php?supplierId=${supId}`;
	if (filter && filter.length) {
		filter.map(cur => {
			url += `&filter[]=${cur}`;
		});
	}
	url += `&search=${searchTerm}`;
	if (pageNo) {
		url += `&page=${pageNo}`;
	}
	axios
		.get(url, {
			cancelToken: new CancelToken(c => (cancel = c))
		})
		.then(data => {
			cb(data.data);
		})
		.catch(function(thrown) {
			if (axios.isCancel(thrown)) {
				console.log('Request canceled', thrown.message, searchTerm);
			}
		});
};

export const raiseWeightDispute = ({ details, cb }) => {
	let url = `/marketplace/static/php/jdCourier/raiseIssue.php`;
	const issueData = new FormData();
	for (let key in details) {
		if (details.hasOwnProperty(key)) {
			if (key != 'evidence') {
				issueData.append(key, details[key]);
			} else {
				if (!details.evidence.length) {
					issueData.append('evidence[]', '');
				} else {
					details.evidence?.map(cur => {
						issueData.append('evidence[]', cur.finalUrl);
					});
				}
			}
		}
	}
	axios.post(url, issueData).then(data => {
		if (data.data.isSuccess) {
			cb && cb(data.data);
		}
	});
};
